<template>
   <v-dialog v-model="show" :persistent="false" :width="768">
      <v-card>
        <v-card-title>
          <span :class="`title1`"><lang :t="title"></lang></span>
          <v-spacer></v-spacer>
          <v-btn icon light @click="closeModal">
            <v-icon>mdi-close</v-icon>
          </v-btn> 
        </v-card-title>
        <v-card-text> 
          <code class="block whitespace-pre overflow-x-scroll" v-text="textValue"></code>

        </v-card-text>
      </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: 'ValueChainAttributeDialog',
    data(){
      return {
        show: false
      }
    },
    props:{
      title: {
        type: String,
        required: true
      },
      body: {
        type: String,
      },
      visible: {
        type: Boolean,
        default: false
      }
    },
    methods:{
      closeModal(){
        this.show = false;
        this.$emit('close');
      },
    },
    created(){

    },
    computed:{
      textValue(){
        if(!this.body) return this.body;
        return JSON.parse(this.body);
      }
    },
    watch: {
      visible:{
        handler(value){
          this.show = value;
        }
      },
      show:{
        handler(value){
          if(!value){
            this.closeModal();
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
